export const isInIframe = (() => {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true; // Assume it's in an iframe if access is blocked
    }
})();